<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        DRF Logs
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-card>
      <v-data-table
        :headers="headers"
        dense
        flat
        :items="listData"
        :options.sync="options"
        :server-items-length="total"
        :loading="orderListLoader"
        class="elevation-1 custom-icon-size mt-6 mr-4"
        :footer-props="{
          itemsPerPageOptions: [25, 50, 100, 250],
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
        }"
      >
        <template v-slot:top>
          <v-form ref="form">
            <v-row class="custom-row pl-4">
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="filter"
                  :items="filters"
                  hide-no-data
                  outlined
                  class="required"
                  label="Select Value"
                  :rules="[(v) => !!v || 'Value is required.']"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(start_date)"
                      label="From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      :rules="[(v) => !!v || 'From Date is required']"
                      required
                      class="required"
                      @click:clear="clearDateInput('this.start_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="start_date"
                    @input="dateMenu = false"
                    :max="getEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  class="custom-text-field required"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(end_date)"
                      label="To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[(v) => !!v || 'To Date is required']"
                      class="required"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.end_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="end_date"
                    @input="dateMenuTo = false"
                    :max="getEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="3" sm="3" class="mb-2">
                <v-btn color="white" @click="clear" style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-5"
                  @click="getLogs"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
          <v-divider class="mb-2 mt-2"></v-divider>
        </template>
      </v-data-table>
    </v-card>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      filters: [],
      filter: "",
      start_date: "",
      end_date: "",
      dateMenuTo: false,
      dateMenu: false,
      total: 0,
      options: {},
      listData: [],
      headers: [
        {
          text: "Headers",
          value: "headers",
          class: "body-1 font-weight-bold",
          align: "left",
          width: "150px",
          sortable: false,
        },
        {
          text: "Api Identity",
          value: "api_identity",
          class: "body-1 font-weight-bold",
          align: "left",
          width: "150px",
          sortable: false,
        },
        {
          text: "Method",
          value: "method",
          class: "body-1 font-weight-bold",
          align: "left",
          width: "150px",
          sortable: false,
        },
        {
          text: "Body",
          value: "body",
          class: "body-1 font-weight-bold",
          align: "left",
          width: "150px",
          sortable: false,
        },
        {
          text: "Identifier 1",
          value: "identifier_1",
          class: "body-1 font-weight-bold",
          align: "left",
          width: "150px",
          sortable: false,
        },

        {
          text: "Identifier 2",
          value: "identifier_2",
          class: "body-1 font-weight-bold",
          align: "left",
          width: "150px",
          sortable: false,
        },

        {
          text: "Identifier 3",
          value: "identifier_3",
          class: "body-1 font-weight-bold",
          align: "left",
          width: "150px",
          sortable: false,
        },

        {
          text: "Identifier 4",
          value: "identifier_4",
          class: "body-1 font-weight-bold",
          align: "left",
          width: "150px",
          sortable: false,
        },
        {
          text: "Identifier 5",
          value: "identifier_5",
          class: "body-1 font-weight-bold",
          align: "left",
          width: "150px",
          sortable: false,
        },
        {
          text: "Response",
          value: "response",
          class: "body-1 font-weight-bold",
          align: "left",
          width: "150px",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  async created() {
    this.getDropdown();
  },
  watch: {
    options: {
      handler() {
        if (this.filters.length > 0) this.getLogs();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["logList", "getLogsData"]),

    clear() {
      this.start_date = null;
      this.end_date = null;
      this.filter = null;
      this.listData = [];
    },
    filterChange() {
      this.start_date = null;
      this.end_date = null;
      this.listData = [];
    },
    getDropdown() {
      this.logList().then((res) => {
        this.filters = res.data;
      });
    },
    clearDateInput(date) {
      if (date == "this.start_date") {
        this.start_date = null;
      } else {
        this.end_date = null;
      }
    },
    getLogs() {
      if (!this.$refs.form.validate()) return;

      let data = {
        api_key: this.filter,
        start_date: this.start_date,
        end_date: this.end_date,
      };

      this.getLogsData({ ...this.options, ...data }).then((res) => {
        this.total = res.data.total;
        this.listData = res.data.records;
      });
    },
  },
};
</script>

<style lang="scss">
.w-100 {
  width: 100%;
}

.padding-form {
  padding: 15px;
}

.required .v-input__control {
  border-color: red;
}

.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
.pre-row {
  display: flex !important;
  padding: 5px 20px 5px 5px !important;
}
.pre-row .v-input__slot {
  min-height: 50px !important;
}
.padding-pre {
  padding-top: 30px;
}
</style>
